module.controller('samplingHomeSampleCtrl', [ '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'ASEBIOL_CONSTANTS', 'permissionStatesService', samplingHomeSampleCtrlFn ]);

function samplingHomeSampleCtrlFn($scope, $rootScope, $state, planSamplingService, alertService, ASEBIOL_CONSTANTS, statesService) {
	vm = this;

	vm.samples = [];
	vm.loading = false;
	vm.idPlanSampling = $scope.idPlanSampling;
	vm.idSampling = $scope.idSampling;

	vm.pagination = {
		current : 1,
		total : 0
	};

	vm.search = function(page) {
		vm.loading = true;

		page = page == undefined ? 1 : page;
		vm.pagination.current = page;

		var filter = {};
		filter.offset = (page - 1) * $rootScope.pageSize;
		filter.limit = $rootScope.pageSize;

		planSamplingService.searchSampleSimpleHome(vm.idPlanSampling, vm.idSampling, filter).then(function(response) {
			vm.loading = false;
			// se leen los datos
			var responseData = response.getData();
			vm.samples = responseData.results;

			// se fromatea las fechas
			vm.samples.forEach(function(s) {
				if (s.scheduleDate)
					s.scheduleDate = moment(s.scheduleDate, ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT).calendar().replace(/\"/gi, '');
				if (s.takenDate)
					s.takenDate = moment(s.takenDate, ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT).calendar().replace(/\"/gi, '');
				// se obtiene el estilo del estado
				s.className = getConstantById(SAMPLE_STATE, s.state).className;
				// si es no conforme se obtiene la nueva muestra
				if (s.state === SAMPLE_STATE.NOT_CONFORM.enumName) {
					s.clonedTo = vm.samples.find(function(s0) {
						if (!s0.clonedFrom)
							return false;
						return s0.clonedFrom.id === s.id;
					});
				}
			});

			vm.pagination.total = responseData.totalRegisters;

		}, function(response) {
			vm.loading = false;
		});
	};

	vm.cancel = function(idPlanSampling, idSampling, idSample) {
		alertService.showSwtWarningQuestion('Cancelar Muestra', function() {
			vm.loading = true;
			planSamplingService.cancelSample(idPlanSampling, idSampling, idSample).then(function(response) {
				vm.loading = false;
				alertService.showSuccess('Muestra cancelada satisfactoriamente');
				vm.search(1);
				$scope.loadHomeInfo(idPlanSampling, idSampling);
			}, function(response) {
				vm.loading = false;
			});
		});
	};

	vm.canCancel = function(state) {
		return statesService.canCancelSample(state);
	};

	vm.canEdit = function(state) {
		return statesService.canEditSample(state);
	};

	vm.canAdd = function() {
		return statesService.canAddSample($scope.planSamplingHome.state);
	};

	/**
	 * clona la muestra
	 */
	vm.cloneSample = function(sample) {
		alertService.showSwtQuestion('Clonar muestra ' + sample.idSample, function() {
			planSamplingService.cloneSample(vm.idPlanSampling, vm.idSampling, sample.id).then(function(response) {
				var dat = response.getData();
				alertService.showSuccess("Muestra clonada satisfactoriamente");
				vm.search(1);
				$scope.loadHomeInfo(vm.idPlanSampling, vm.idSampling);
			}, function() {
			});
		});
	}

	vm.search(1);

}
